// extracted by mini-css-extract-plugin
module.exports = {"tooltipArrow":"_ec21c3e","header":"_265cc60"};